var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2H6v12h14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13h6.586l-2.293 2.293 1.414 1.414L20.414 12l-4.707-4.707-1.414 1.414L16.586 11H10v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLogout);
export default __webpack_public_path__ + "static/media/ic_action_logout.b19caff24fe368a924cb648b036f19ce.svg";
export { ForwardRef as ReactComponent };